module.exports = __webpack_public_path__ + "static/media/logo-2.1db42a84.png";